import EventBus from "@/core/services/EventBus/EventBus";
import Core from "@/core/Core";

/**
 * Базовый класс для всех сервисов приложения
 * Предоставляет доступ к Core и базовую структуру для сервисов
 * Сервисы работают с событиями напрямую через Core.eventBus
 */
abstract class BaseService {
  static get core(): typeof Core {
    return Core;
  }

  static get eventBus(): typeof EventBus {
    return EventBus;
  }

  static get dao(): any {
    // TODO переопределить в потомке
    throw new Error('DAO должен быть переопределён в потомке');
  }

  /** Поменял с void на any, потому что в потомках мы можем возвращать сам класс сервиса из метода init **/
  static async init(): Promise<any> {
    Core.debug(`📦 ${this.name} инициализирован`);
  }
}

export default BaseService;
